// @ts-ignore
import pluralize from 'pluralize'

export function plural(word: string, amount?: number): string {
  return pluralize(word, amount)
}

export function singular(word: string): string {
  return pluralize.singular(word)
}
